'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useContext, createContext } from 'react';
const ProductContext = createContext({});
export const ProductWrapper = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [addReviewFormOpen, setAddReviewFormOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setAddReviewFormOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openAddReviewForm = t1;
  let t2;
  if ($[1] !== addReviewFormOpen) {
    t2 = {
      addReviewFormOpen,
      setAddReviewFormOpen,
      openAddReviewForm
    };
    $[1] = addReviewFormOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <ProductContext.Provider value={t2}>{children}</ProductContext.Provider>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const useProductContext = () => {
  return useContext(ProductContext);
};